import Axios from "../helper/appConfig";

export const CheckMemberService = (email, branchid) => {
  const body = { username: email, associatedbranch: branchid };
  return Axios.post("api/public/checkmember", body);
};

export const SendEmailService = (name, email, otp) => {
  let emailbody = {
    messagetype: "EMAIL",
    message: {
      // "content": `Dear Customer, your OTP ${otp} - ${"CyberYouthAustralia"}`,
      content: `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="ie=edge" />
    <title>CyberYouth Australia</title>

    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap"
      rel="stylesheet"
    />
  </head>
  <body
    style="
      margin: 0;
      font-family: 'Poppins', sans-serif;
      background: #ffffff;
      font-size: 14px;
    "
  >
    <div
      style="
        max-width: 680px;
        margin: 0 auto;
        padding: 45px 30px 60px;
        background: #f4f7ff;
        background-image: url(https://img.freepik.com/free-vector/white-abstract-wallpaper_23-2148830028.jpg);
        background-repeat: no-repeat;
        background-size: 800px 452px;
        background-position: top center;
        font-size: 14px;
        color: #434343;
      "
    >
      <header>
        <table style="width: 100%;">
          <tbody>
            <tr style="height: 0;">
              <td>
                <img
                  alt="logo"
                   src="https://res.cloudinary.com/dlopjt9le/image/upload/v1712078406/u7dr2rkwjwl49wkrmaiv.jpg"
                  height="50px"
                />
              </td>

            </tr>
          </tbody>
        </table>
      </header>

      <main>

        <div
          style="
            margin: 0;
            margin-top: 40px;
            padding: 5px 30px 10px;
            background: #ffffff;
            border-radius: 30px;
            text-align: center;
          "
        >
                  <h6 style="font-size:20px;font-weight:600;text-align:left;color:#000054;">Verify email and sign in</h6>

                   <p
              style="
                margin: 0;
                font-weight: 500;
                letter-spacing: 0.56px;
              "
            >
            <label style="text-align:left !important;">Dear ${name},</label>
            <br/><br/>
             This is your unique code, which you can use to securely sign in to your https://www.spinnakerlakedillon.com/ account without using a password.

            </p>
          <div style="width: 100%; max-width: 489px; margin: 0 auto;">


            <h1
              style="
                margin: 0;
                font-size: 24px;
                font-weight: 500;
                color: #1f1f1f;
              "
            >
              Your OTP
            </h1>


            <p
              style="
                margin: 0;
                margin-top: 30px;
                font-size: 40px;
                font-weight: 600;
                letter-spacing: 25px;
                color: #ba3d4f;
              "
            >
              ${otp}
            </p>

            <p>Please note this code can only be used once and expires after 10 minutes. Do not share this code with anyone else.
<br/><br/>
If you didn’t request a verification code for the account linked to ${email}, you can ignore this email.</p>
          </div>
        </div>


      </main>


    </div>
  </body>
</html>`,
      to: email,
      subject: "Spinnakerlake Dillon login OTP",
    },
  };
  return Axios.post("api/communications/send", emailbody);
};

export const checkGuestUserService = (mailid) => {
  let body = {
    search: [
      {
        searchfield: "branchid",
        searchvalue: localStorage.getItem("branchid"),
        datatype: "ObjectId",
        criteria: "eq",
      },
      {
        searchfield: "property.primaryemail",
        searchvalue: mailid,
        datatype: "text",
        criteria: "eq",
      },
      {
        searchfield: "status",
        searchvalue: "active",
        datatype: "text",
        criteria: "eq",
      },
    ],
    select: [
      {
        fieldname: "property",
        value: 1,
      },
      {
        fieldname: "category",
        value: 1,
      },
    ],
  };

  return Axios.post(`api/members/filter`, body);
};

export const SendSmsService = (body) => {
  return Axios.post("api/communications/send", body);
};

export const LoginService = (body) => {
  return Axios.post(`api/auth/memberlogin`, body);
};

export const isExistDetailService = (body) => {
  return Axios.post(`api/prospects/filter`, body);
};

export const getLoginDetailService = (id, schemaname) => {
  return Axios.get(`api/${schemaname}/${id}`);
};

export const updateProfileService = (id, usertype, payload) => {
  return Axios.patch(`api/${usertype}/${id}`, payload);
};

export const getTypeService = (usertype, id) => {
  return Axios.get(`api/${usertype}/${id}`);
};

export const otpSendService = (postData) => {
  return Axios.get(`api/public/sendotp`, postData);
};

export const getFilterProfileData = (usertype) => {
  let body = {
    search: [
      {
        searchfield: "_id",
        searchvalue: localStorage.getItem("authkey"),
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
  };
  return Axios.post(`api/${usertype}/filter`, body);
};

export const branchData = () => {
  let data = {
    search: [
      {
        searchfield: "_id",
        searchvalue: localStorage.getItem("branchid"),
        criteria: "eq",
        datatype: "ObjectId",
      },
    ],
    select: [
      {
        fieldname: "property",
        value: 1,
      },
      {
        fieldname: "timezone",
        value: 1,
      },
    ],
  };
  return Axios.post(`api/branches/filter`, data);
};
